import { render } from "./LogInForm.vue?vue&type=template&id=5637dfc9"
import script from "./LogInForm.vue?vue&type=script&lang=js"
export * from "./LogInForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PCHOME\\projetos2022\\live-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__